/**
 * Shared constants and style values for Interactive Learning components
 */

export const DOCUMENTS_PANEL = {
  primaryColor: '#FD99C5',
  primaryHover: '#FC7BB5',
  freeBadgeBg: '#dcfce7',
  freeBadgeColor: '#166534',
  borderColor: '#FD99C5',
  panelBg: '#FFF5F9',
};

export const DOCUMENT_ICON_PATH =
  'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z';

export const POST_MESSAGE_TYPES = {
  SHOW_DOCUMENTS_BUTTON: 'SHOW_DOCUMENTS_BUTTON',
  HIDE_DOCUMENTS_BUTTON: 'HIDE_DOCUMENTS_BUTTON',
  SHOW_DOCUMENTS_PANEL: 'SHOW_DOCUMENTS_PANEL',
  HIDE_DOCUMENTS_PANEL: 'HIDE_DOCUMENTS_PANEL',
  TOGGLE_DOCUMENTS_PANEL: 'TOGGLE_DOCUMENTS_PANEL',
};
